export const page = async () => {
    // if (window.location.pathname == '/juego/vuela'){
    //     var modalBacanoGameAsk = document.getElementById("modalBacanoGameAsk");
    //     var checkPlayModal = document.getElementById("checkPlayModal") as HTMLInputElement;
    //     var botonPlayModal = document.getElementById("botonPlayModal");
    //     var body = document.querySelector("body");
    //     body.style.position = "static";
    //     body.style.height = "100%";
    //     body.style.overflow = "hidden";
    
    //     botonPlayModal.onclick = function() {
    //         if (checkPlayModal.checked){
    //             modalBacanoGameAsk.style.display = "none";
            
    //             body.style.position = "inherit";
    //             body.style.height = "auto";
    //             body.style.overflow = "visible";
    //         }
    //     }
    // }
}